import React from 'react'
import PropTypes from 'prop-types'
import { Glyph } from '../../../../LEGACY/Glyph'
import { ButtonOLD } from '@lmc/ui-kit'

export default function ZonesTitleBar({
  isOpen,
  isNoZone,
  onDelete,
  onEdit,
  title,
  toggleOpen,
}) {
  return (
    <div>
      <div style={styles.content}>
        <h2 style={styles.title}>{title}</h2>
        {!isNoZone && (
          <div style={styles.buttonContainer}>
            <ButtonOLD
              className="edit-zone"
              onClick={onEdit}
              type="secondary"
              icon={<Glyph name="pencil" />}
            >
              Edit
            </ButtonOLD>
            <ButtonOLD
              className="delete-zone"
              onClick={onDelete}
              style={styles.deleteButton}
              type="danger"
              ghost
              icon={<Glyph name="trashcan" />}
            >
              Delete
            </ButtonOLD>
          </div>
        )}
        <div
          className="toggle-zone-open"
          onClick={toggleOpen}
          style={styles.iconContainer}
        >
          <Glyph
            name={isOpen ? 'chevron-up' : 'chevron-down'}
            size="small"
            style={styles.icon}
          />
        </div>
      </div>
    </div>
  )
}

const styles = {
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    flex: 1,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: 16,
  },
  deleteButton: {
    marginLeft: 5,
  },
  divider: {
    height: 2,
    marginBottom: 10,
    width: '100%',
  },
  iconContainer: {
    cursor: 'pointer',
    height: 16,
    width: 16,
    padding: '8px 15px 0px 15px',
  },
  title: {
    height: 24,
    hyphens: 'auto',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontWeight: 700,
    fontSize: 20,
    marginBottom: 0,
  },
}

ZonesTitleBar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  title: PropTypes.string.isRequired,
  toggleOpen: PropTypes.func.isRequired,
}
